/*
 * @Author: jackshen
 * @Date: 2021-07-08 11:42:11
 * @LastEditors: wenlin
 * @LastEditTime: 2021-07-08 14:29:17
 * @Description:
 */
import request from '@/utils/request1'
// 下级指标获取
export function getTags (id, params) {
  return request({
    url: '/api/cases/tags/' + id,
    method: 'get',
    params: params
  })
}
// 指标获取案例
export function getList (data) {
  return request({
    url: '/api/cases/list',
    method: 'post',
    data
  })
}
export function categoryCase (category, id) {
  return request({
    url: '/api/cases/category/' + category + '?id=' + id,
    method: 'post'
  })
}

export function points () {
  return request({
    url: '/api/cases/points',
    method: 'post'
  })
}



// WEBPACK FOOTER //
// ./src/api/case.js